angular.module('content.widgets.ChoiceDecisionWidgetController', [
  'content.widgets.ChoiceDecisionWidgetService'
])

/**
 * The ChoiceDecisionWidgetController manages scope logic and user
 * interaction.
 *
 * @class ChoiceDecisionWidgetController
 * @constructor
 * @module content.widgets.ChoiceDecisionWidgetController
 **/
.controller('ChoiceDecisionWidgetController', [
  '$scope',
  '$rootScope',
  '$sce',
  '$state',
  'ChoiceDecisionWidgetService',
  'StatesService',
  'SimulationService',
  function (
    $scope,
    $rootScope,
    $sce,
    $state,
    ChoiceDecisionWidgetService,
    StatesService,
    SimulationService
  ) {
    'use strict';

    $scope.formattedModel = {};

    $scope.formData = null;

    $scope.state = null;

    $scope.attempts = 0;

    $scope.reset = true;

    $scope.ready = false;

    $scope.display = {
      choiceFeedback: false,
      scoringFeedback: false
    };

    $scope.getModel = function () {
      return ChoiceDecisionWidgetService.getModel($scope.model, $scope.form.model);
    };

    $scope.selectInput = function (formData, choice, multiple) {
      if (!$scope.formData.radio) {
        $scope.formData.radio = {
          id: null
        };
      }
      if (multiple) {
        $scope.formData.checkboxes[choice.id] = !$scope.formData.checkboxes[choice.id];
      } else {
        $scope.formData.radio.id = choice.id;
      }
    };

    /**
     * UI trigger to submit a choice form.  Utilizes
     * the ChoiceDecionService to process the form.
     */
    $scope.submit = function submit() {
      var feedback;

      if ($scope.formattedModel.multiple) {
        feedback = ChoiceDecisionWidgetService
          .processMultiple(
            $state.params.stateId,
            $scope.model.content.decisions,
            $scope.formData.checkboxes,
            $scope.reset
          );
      } else {
        feedback = ChoiceDecisionWidgetService
          .processSingle(
            $state.params.stateId,
            $scope.model.content.decisions,
            $scope.formData.radio,
            $scope.reset
          );
      }

      feedback.then(function (response) {
        $scope.formattedModel = ChoiceDecisionWidgetService
          .addFeedbackToModel(
            $scope.formattedModel,
            response.content.feedback,
            response.content.decision.content,
            response.id
          );
        $scope.attempts += 1;
        $scope.next();

        // if the choice feedback is null (default) or an empty string (set then removed)...
        if ((response.content.feedback.choiceFeedback === null ||
          response.content.feedback.choiceFeedback === '') &&
          $scope.state !== 'scoringFeedback') {
          // and if the maximum attempts have been reched or the answer chosen is true...
          if ($scope.attempts >= $scope.formattedModel.feedback.attempts.max ||
            response.content.feedback.correct.isCorrect) {
            // fire off next() for the user to avoid a seemingly redundant screen with no feedback.
            $scope.next();
          }
        }
        return;
      })
      .catch(function (err) {
        console.log(err);
      });
    };

    /**
     * Determines what the next state of the choice
     * workflow to present.
     *
     * TODO: This should be broken out into a service
     */
    $scope.next = function next() {
      var feedback;
      $scope.processing = true;
      switch ($scope.state) {
        case 'choiceFeedback':
          // if there are still attempts and the answer is not correct
          if (
            $scope.attempts < $scope.formattedModel.feedback.attempts.max
            && !$scope.formattedModel.feedback.correct.isCorrect
          ) {
            $scope.state = null;
            $scope.reset = false;
            disableSelected();
            resetChoices();
          } else if ($scope.formattedModel.model === 'state.followUp') {
            // no more attempts or question has been answered correctly
            // follow up decision will not show feedback
            StatesService.goToState($scope.formattedModel.feedback.targetId);
          } else {
            // other types will show feedback
            $scope.state = 'scoringFeedback';
            $scope.display.scoringFeedback = true;
          }
          break;
        case 'scoringFeedback':
          feedback = angular.element('#difficult-decision-feedback');
          if (feedback && !_.isEmpty(feedback.val())) {
            ChoiceDecisionWidgetService.processDifficultDecision(
              $state.params.stateId,
              feedback.val(),
              $scope.formattedModel.id
            );
          }
          StatesService.goToState($scope.formattedModel.feedback.targetId);
          break;
        default:
          // widgets are locked when feedback is in progress.
          // Unlocked when state is changed.  See StatesService.gotToState()
          $rootScope.widgetLock = true;
          SimulationService.addToDisabled($scope.stateId);
          SimulationService.setCurrentProgress($scope.formattedModel.feedback.targetId);
          if ($scope.formattedModel.model === 'state.knowledgeDecision') {
            $scope.state = 'scoringFeedback';
            $scope.display.scoringFeedback = true;
          } else if ($scope.formattedModel.model === 'state.actionDecision') {
            // if multiple attempts are allowed
            // DCS-161
            // TODO remove commented out code

            /*
            if ($scope.formattedModel.multiple) {
              $scope.state = 'scoringFeedback';
              $scope.display.scoringFeedback = true;
            } else {
              $scope.state = 'choiceFeedback';
              $scope.display.choiceFeedback = true;
            }
            */

            // DCS-190
            $scope.state = 'choiceFeedback';
            $scope.display.choiceFeedback = true;
          } else if ($scope.formattedModel.model === 'state.followUp') {
            $scope.state = 'choiceFeedback';
            $scope.display.choiceFeedback = true;
          } else {
            StatesService.goToState($scope.formattedModel.feedback.targetId);
          }
          break;
      }
    };

    /**
     * Determines if the checkbox is required or not
     */
    $scope.checkboxRequired = function checkboxRequired() {
      var result = true;

      _.forEach(_.keys($scope.formData.checkboxes), function (key) {
        if ($scope.formData.checkboxes[key]) {
          result = false;
        }
      });

      return result;
    };

    /**
     * Disables choices based on feedback
     */
    function disableSelected() {
      _.forEach($scope.formattedModel.feedback.disabled, function (obj) {
        var found = _.find($scope.formattedModel.choices, { id: obj.id });
        found.disabled = true;
      });
    }


    /**
     * Resets the state of choices on the form
     */
    function resetChoices() {
      $scope.formData = {
        checkboxes: []
      };

      $scope.display = {
        choiceFeedback: false,
        scoringFeedback: false
      };

      $scope.ready = false;
    }

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      // emits an event passing the current scope.  This scope is picked up by the
      // associated theme to register as the active scope.
      // This event is required to initialize a widget
      $scope.$emit('setCurrentContentScope', $scope);

      $scope.formattedModel = {
        title: $scope.model.label,
        multiple: $scope.model.content.decisions.content.multiple,
        model: $scope.model.content.decisions.content.model,
        stem: $sce.trustAsHtml($scope.model.content.decisions.content.stem),
        media: $scope.model.content.decisions.content.media,
        choices: _.shuffle($scope.model.content.decisions.content.choices)
      };

      resetChoices();

      if (!_.isArray($scope.model.content.rules)) {
        $scope.form = ChoiceDecisionWidgetService.configureForm($scope.model);
      }
    }

    initialize();
  }
]);
